import { connect } from 'react-redux';
import Experience from '../components/Experience';
import { open } from 'store/modules/modal';
import { add, selected, selectExperience, deleteExperience } from '../modules';

const mapStateToProps = state => {
  return {
    mam: state.mam,
    selected: selected(state),
  };
};

const mapDispatchToProps = dispatch => ({
  add() {
    dispatch(add());
  },

  selectExperience(experience) {
    dispatch(selectExperience(experience));
  },

  deleteExperience(campaignId, id, name) {
    dispatch(
      open({
        modalType: 'confirm',
        modalProps: {
          message: `Delete experience '${name}'?`,
          id,
          handleYes: id => {
            dispatch(deleteExperience(campaignId, id));
          },
        },
      })
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Experience);
